module.exports = __webpack_public_path__ + "assets/img/slide06.4992aebe.svg";